import { render } from "./TextareaInput.vue?vue&type=template&id=63631d25"
import script from "./TextareaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TextareaInput.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/components/form/inputs/TextareaInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63631d25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63631d25', __exports__)) {
    api.reload('63631d25', __exports__)
  }
  
  module.hot.accept("./TextareaInput.vue?vue&type=template&id=63631d25", () => {
    api.rerender('63631d25', render)
  })

}


export default __exports__